var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "打印预览",
        visible: _vm.show,
        fullscreen: "",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c("div", [
        _c(
          "span",
          {
            staticClass: "dialog-footer",
            staticStyle: { display: "flex", "margin-bottom": "20px" },
          },
          [
            _c("div", { staticStyle: { flex: "1" } }),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.print } },
              [_vm._v("打印")]
            ),
            _c(
              "el-button",
              {
                on: {
                  click: function ($event) {
                    _vm.show = false
                  },
                },
              },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { attrs: { id: "printId" } }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
              "font-size": "24px",
              "margin-bottom": "20px",
              "margin-top": "20px",
            },
          },
          [_vm._v(" 体质检测分析报告 ")]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
            },
          },
          [
            _c("div", [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItem" }, [_vm._v("昵称")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.userName)),
                ]),
                _c("div", { staticClass: "formItem" }, [_vm._v("性别")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.sexSign == 1 ? "男" : "女")),
                ]),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItem" }, [_vm._v("年龄")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.age)),
                ]),
                _c("div", { staticClass: "formItem" }, [_vm._v("出生日期")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.birthDate)),
                ]),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItem" }, [_vm._v("检测日期")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.diagTime)),
                ]),
                _c("div", { staticClass: "formItem" }, [_vm._v("检测门店")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.storeName)),
                ]),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItem" }, [_vm._v("门店地址")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.contactAddress)),
                ]),
                _c("div", { staticClass: "formItem" }, [_vm._v("联系电话")]),
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v(_vm._s(_vm.printData.contactPhone)),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              margin: "30px 0 10px 0",
              "font-size": "18px",
              "font-weight": "bold",
              display: "flex",
            },
          },
          [
            _c("div", {
              staticStyle: {
                "border-left": "5px solid rgb(22, 93, 255)",
                padding: "0 0 10px 10px",
                "margin-left": "10px",
              },
            }),
            _vm._v(" 体质 "),
          ]
        ),
        _c("div", { staticStyle: { padding: "10px" } }, [
          _vm.subPhyCount === 0
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "main-phy-large",
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center",
                      padding: "20px",
                      background:
                        "linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%)",
                      "border-radius": "12px",
                      margin: "20px auto",
                      "max-width": "600px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "100%",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "20px" } }, [
                          _vm.printData.mainPhyCode
                            ? _c("img", {
                                staticStyle: { width: "80px", height: "80px" },
                                attrs: {
                                  src: require(`@/assets/health/${_vm.printData.mainPhyCode}.png`),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("div", { staticStyle: { flex: "1" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "20px",
                                "font-weight": "bold",
                                color: "#165dff",
                                "margin-bottom": "8px",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.printData.mainPhyName) + " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                color: "#666",
                              },
                            },
                            [
                              _vm._v(" 程度："),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    color: "#165dff",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.printData.mainPhyPct) + "%")]
                              ),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c("img", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: {
                              src: require("@/assets/icon/zhutizhi.png"),
                              alt: "",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm.subPhyCount === 1
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "stretch",
                      margin: "20px auto",
                      "max-width": "800px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "main-phy-large",
                        staticStyle: {
                          flex: "2",
                          "margin-right": "15px",
                          padding: "25px",
                          background:
                            "linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%)",
                          "border-radius": "12px",
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "20px" } }, [
                          _vm.printData.mainPhyCode
                            ? _c("img", {
                                staticStyle: { width: "80px", height: "80px" },
                                attrs: {
                                  src: require(`@/assets/health/${_vm.printData.mainPhyCode}.png`),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("div", { staticStyle: { flex: "1" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "22px",
                                "font-weight": "bold",
                                color: "#165dff",
                                "margin-bottom": "8px",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.printData.mainPhyName) + " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "18px",
                                color: "#666",
                              },
                            },
                            [
                              _vm._v(" 程度："),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    color: "#165dff",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.printData.mainPhyPct) + "%")]
                              ),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c("img", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: {
                              src: require("@/assets/icon/zhutizhi.png"),
                              alt: "",
                            },
                          }),
                        ]),
                      ]
                    ),
                    _vm._l(_vm.getSubPhyList(), function (item) {
                      return _c(
                        "div",
                        {
                          key: item.index,
                          staticClass: "sub-phy-item",
                          staticStyle: {
                            flex: "1",
                            padding: "20px",
                            background: "#f9fafc",
                            "border-radius": "10px",
                            border: "1px solid #e5e7eb",
                            display: "flex",
                            "align-items": "center",
                            "margin-left": "15px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-right": "15px" } },
                            [
                              _c("img", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: {
                                  src: require(`@/assets/health/${item.code}.png`),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                          _c("div", { staticStyle: { flex: "1" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "600",
                                  color: "#333",
                                  "margin-bottom": "5px",
                                },
                              },
                              [_vm._v(" " + _vm._s(item.name) + " ")]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#666",
                                },
                              },
                              [_vm._v(" 程度：" + _vm._s(item.pct) + "% ")]
                            ),
                          ]),
                          _c("div", [
                            _c("img", {
                              staticStyle: { width: "40px", height: "40px" },
                              attrs: {
                                src: require("@/assets/icon/futizhi.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "main-phy-large",
                    staticStyle: {
                      padding: "25px",
                      background:
                        "linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%)",
                      "border-radius": "12px",
                      margin: "20px auto",
                      "max-width": "700px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "20px" } }, [
                      _vm.printData.mainPhyCode
                        ? _c("img", {
                            staticStyle: { width: "80px", height: "80px" },
                            attrs: {
                              src: require(`@/assets/health/${_vm.printData.mainPhyCode}.png`),
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ]),
                    _c("div", { staticStyle: { flex: "1" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "22px",
                            "font-weight": "bold",
                            color: "#165dff",
                            "margin-bottom": "8px",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.printData.mainPhyName) + " ")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { "font-size": "18px", color: "#666" } },
                        [
                          _vm._v(" 程度："),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#165dff",
                              },
                            },
                            [_vm._v(_vm._s(_vm.printData.mainPhyPct) + "%")]
                          ),
                        ]
                      ),
                    ]),
                    _c("div", [
                      _c("img", {
                        staticStyle: { width: "60px", height: "60px" },
                        attrs: {
                          src: require("@/assets/icon/zhutizhi.png"),
                          alt: "",
                        },
                      }),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-wrap": "wrap",
                      "justify-content": "center",
                      "margin-top": "30px",
                    },
                  },
                  _vm._l(_vm.getSubPhyList(), function (item) {
                    return _c(
                      "div",
                      {
                        key: item.index,
                        staticClass: "sub-phy-item",
                        staticStyle: {
                          width: "280px",
                          margin: "10px",
                          padding: "15px",
                          background: "#f9fafc",
                          "border-radius": "10px",
                          border: "1px solid #e5e7eb",
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "15px" } }, [
                          _c("img", {
                            staticStyle: { width: "50px", height: "50px" },
                            attrs: {
                              src: require(`@/assets/health/${item.code}.png`),
                              alt: "",
                            },
                          }),
                        ]),
                        _c("div", { staticStyle: { flex: "1" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                "font-weight": "600",
                                color: "#333",
                                "margin-bottom": "5px",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.name) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#666",
                              },
                            },
                            [_vm._v(" 程度：" + _vm._s(item.pct) + "% ")]
                          ),
                        ]),
                        _c("div", [
                          _c("img", {
                            staticStyle: { width: "40px", height: "40px" },
                            attrs: {
                              src: require("@/assets/icon/futizhi.png"),
                              alt: "",
                            },
                          }),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
        ]),
        _c(
          "div",
          {
            staticStyle: {
              margin: "30px 0 10px 0",
              "font-size": "18px",
              "font-weight": "bold",
              display: "flex",
            },
          },
          [
            _c("div", {
              staticStyle: {
                "border-left": "5px solid rgb(22, 93, 255)",
                padding: "0 0 10px 10px",
                "margin-left": "10px",
              },
            }),
            _vm._v(" 面诊 "),
          ]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "center", margin: "10px 0" } },
          [
            _c("img", {
              staticStyle: { height: "200px" },
              attrs: { src: _vm.getsrc(_vm.printData.faceImg), alt: "" },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
            },
          },
          [
            _c("div", [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItem" }, [_vm._v("指标")]),
                _c(
                  "div",
                  { staticClass: "formItem", staticStyle: { width: "300px" } },
                  [_vm._v("说明")]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("面部颜色"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "faceColorSign",
                            _vm.printData.faceColorSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("面部色泽"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "faceLustreSign",
                            _vm.printData.faceLustreSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("嘴唇检测"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "lipRecognitionSign",
                            _vm.printData.lipRecognitionSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [_vm._v("嘴唇")]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "lipColorSign",
                            _vm.printData.lipColorSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              margin: "30px 0 10px 0",
              "font-size": "18px",
              "font-weight": "bold",
              display: "flex",
            },
          },
          [
            _c("div", {
              staticStyle: {
                "border-left": "5px solid rgb(22, 93, 255)",
                padding: "0 0 10px 10px",
                "margin-left": "10px",
              },
            }),
            _vm._v(" 舌诊 "),
          ]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "center", margin: "10px 0" } },
          [
            _c("img", {
              staticStyle: { height: "200px" },
              attrs: { src: _vm.getsrc(_vm.printData.tongueImg), alt: "" },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
            },
          },
          [
            _c("div", [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItem" }, [_vm._v("指标")]),
                _c(
                  "div",
                  { staticClass: "formItem", staticStyle: { width: "300px" } },
                  [_vm._v("说明")]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("舌裂纹检测"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "tongueCrackSign",
                            _vm.printData.tongueCrackSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("舌胖瘦检测"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "tongueFatSign",
                            _vm.printData.tongueFatSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("舌苔厚薄检测"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "tongueCoatThickSign",
                            _vm.printData.tongueCoatThickSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("舌苔颜色检测"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "tongueCoatColorSign",
                            _vm.printData.tongueCoatColorSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "formItemwhite" }, [
                  _vm._v("舌质颜色检测"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "formItemwhite",
                    staticStyle: { width: "300px", background: "#fff" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getOptions(
                            "tongueColorSign",
                            _vm.printData.tongueColorSign
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              margin: "30px 0 10px 0",
              "font-size": "18px",
              "font-weight": "bold",
              display: "flex",
            },
          },
          [
            _c("div", {
              staticStyle: {
                "border-left": "5px solid rgb(22, 93, 255)",
                padding: "0 0 10px 10px",
                "margin-left": "10px",
              },
            }),
            _vm._v(" 方案 "),
          ]
        ),
        _c("div", {
          staticStyle: { "text-align": "start", padding: "0 20px" },
          domProps: {
            innerHTML: _vm._s(
              _vm.schemeHtml.head ? _vm.schemeHtml.head.htmlContent : ""
            ),
          },
        }),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
              width: "100%",
              "margin-top": "30px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  "justify-content": "center",
                  "align-items": "center",
                  padding: "20px",
                  border: "1px solid #eee",
                  "border-radius": "8px",
                },
              },
              [
                _c("img", {
                  staticStyle: {
                    width: "120px",
                    height: "120px",
                    "object-fit": "contain",
                  },
                  attrs: { src: require("@/assets/health/qr.jpg") },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      "font-size": "14px",
                      color: "#666",
                    },
                  },
                  [_vm._v(" 扫码在手机上查看报告 ")]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }